export default __webpack_public_path__ + "static/media/img-0556-denmark-premium-face.8e0880a1.png";